import styles from "./HomeHero.module.css";

// The homepage header. Visually this is the block the catalog already had when
// it lived at /library (NavigationTop without breadcrumbs), so the page keeps
// its familiar look. The only change is the tag: h1 instead of h2, because this
// is now the site's root page and needs a real top-level heading.
//
// The h1 text must stay in sync with the "h1" value the crawler render returns
// for "/" (backend/config/seo_views.py, _library): dynamic rendering has to
// mirror what humans see.
const HomeHero = () => (
  <section className={`height ${styles.main}`}>
    <h1 className="h2-bold">Distortion Grids Database</h1>
    <div className={`h4-light ${styles.text}`}>
      Search for available distortion grids for chosen camera and lens models.
    </div>
  </section>
);

export default HomeHero;
